import { DistributionTable, DistributionTableSchema } from "src/app/infra/database/dexie/instance/chat/schema/destribution";
import { chatDatabase } from "src/app/infra/database/dexie/instance/chat/service";
import { DexieRepository } from "src/app/infra/repository/dexie/dexie-repository.service";



export abstract class  IDistributionLocalRepository extends DexieRepository<DistributionTable, DistributionTable> implements IDistributionLocalRepository {

}
